export default "__VITE_PUBLIC_ASSET__e79660c8__"